import { IsNotEmpty, IsString, NotEquals } from 'class-validator';

export class NomenclaturePositionRestoreRequest {
    @IsString()
    @IsNotEmpty()
    @NotEquals('0')
    public uuid: string;

    constructor(data?: Partial<NomenclaturePositionRestoreRequest>) {
        this.uuid = data && data.uuid;
    }
}
